export default "__VITE_ASSET__2_l9qiJS__"